/* AUTOGENERATED FILE - DO NOT EDIT CONTENTS */

export const projectId = "vjerzfqcotupaatmzxgs"
export const publicAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZqZXJ6ZnFjb3R1cGFhdG16eGdzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzIwNTUwNzksImV4cCI6MjA4NzYzMTA3OX0.T5YhbK5-4KXnGlxEE5EFWX4OHoAR2qA-lC6GEIGUEtU"